import { createORM } from "pinia-orm";
import BusinessPartner from "./BusinessPartner.js";
import Address from "./Address.js";
import Agency from "./Agency.js";
import User from "./User.js";
import PendingBusinessPartner from "./PendingBusinessPartner.js";
import PendingAddress from "./PendingAddress.js";
import Request from "./Request.js";
import RequestComment from "./RequestComment.js";
import DocumentType from "./DocumentType.js";
import Document from "./Document.js";

export const orm = createORM({
  models: [
    BusinessPartner,
    Address,
    Agency,
    User,
    PendingBusinessPartner,
    PendingAddress,
    Request,
    RequestComment,
    DocumentType,
    Document,
  ],
});

export {
  BusinessPartner,
  Address,
  Agency,
  User,
  PendingBusinessPartner,
  PendingAddress,
  Request,
  RequestComment,
  DocumentType,
  Document,
};
